
const fields = [
		{
			label:'Entry Type',
			name:'entry_type',
			type:'select',
			dataType:'Object',
			readonly:false,
			layout:'col s12 ',
			values: {},
			options:[
				{
					name: 'Judgment',
					prop: 'Judgment',
					id: 22,
				},
				{
					name: 'Legislation',
					prop: 'Legislation',
					id: 23,
				},
				{
					name: 'Book',
					prop: 'Book',
					id: 24,
				}
			]
		},
		// record starts here
		{
			name:'name',
			label:'Title',
			type:'text',
			values:'',
			readonly:false,
			isFor:['Judgment', 'Legislation', 'Book'],
			layout:'col s12'
		},
		{
			label: "Type",
			name: "type",
			type: "select",
			dataType:'Object',
			layout:'col s6',
			isFor:'Legislation',
			values:{},
			options :[
				{
					name: "Legislation",
					prop: "Legislation",
					id: 1,
				},
				{
					name: "Statutory Instrument",
					prop: "Statutory Instrument",
					id: 2,
				},
				{
					name: "Order",
					prop: "Order",
					id: 3,
				},
			]
		},
		{
			name:'principal_act',
			label:'Principal Act',
			type:'text',
			values:'',
			readonly: false,
			layout:'col s12',
			isFor:'Legislation',
		},
		{
			label: 'Notes',
			name: 'notes',
			type: 'text_area',
			values:'',
			readonly:false,
			layout:'col s12',
			isFor:'Legislation',
		},
		{
			label: "Published Date",
			name: "published_date",
			type:'date',
			values:'',
			readonly:false,
			layout:'col s6',
			isFor:'Legislation',
		},
		{
			name:'sub_title',
			label:'Sub Title',
			type:'text',
			values:'',
			readonly:false,
			layout:'col s12',
			isFor:['Judgment', 'Legislation','Book'],
		},
		{
			label: 'Parties',
			name: 'parties',
			type: 'text_area',
			values:'',
			readonly:false,
			layout:'col s12',
			isFor:'Judgment',
		},
		{
			label: 'Delivered By',
			name: 'delivered_by',
			type: 'text',
			values:'',
			readonly:false,
			layout:'col s6',
			isFor:'Judgment',
		},
		{
			label: 'Claim No.',
			name: 'claim_no',
			type: 'text',
			values:'',
			readonly:false,
			layout:'col s6',
			isFor:'Judgment',
		},
		{
			label: "Territory",
			name: "territory",
			type:'select',
			readonly:false,
			dataType:'Object',
			layout:'col s6',
			isFor:['Judgment', 'Legislation'],		
			options:[
				{
					name: 'Anguilla',
					prop: 'Anguilla',
					id: 1,
				},
				{
					name: "Antigua & Barbuda",
					prop: "Antigua & Barbuda",
					id: 2,
				},
				{
					name: "Commonwealth of Dominica",
					prop: "Commonwealth of Dominica",
					id: 3,
				},
				{
					name: "Grenada",
					prop: "Grenada",
					id: 4,
				},
				{
					name: "Montserrat",
					prop: "Montserrat",
					id: 5,
				},
				{
					name: "St. Kitts  Nevis",
					prop: "St. Kitts  Nevis",
					id: 6,
				},
				{
					name: "Saint Lucia",
					prop: "Saint Lucia",
					id: 7,
				},
				{
					name: "St. Vincent",
					prop: "St. Vincent",
					id: 8,
				},
				{
					name: "Territory of the Virgin Islands",
					prop: "Territory of the Virgin Islands",
					id: 9,
				},
			],
		},
		{
			label: "Court",
			name: "court",
			type: "select",
			layout:'col s6',
			dataType:'Object',
			isFor:'Judgment',
			options :[
				{
					name: "High Court",
					prop: "High Court",
					id: 1,
				},
				{
					name: "Court of Appeal",
					prop: "Court of Appeal",
					id: 2,
				},
			]
		},
		{
			label: "Subject",
			name: "subject",
			type: "text",
			values:'',
			readonly:false,
			isFor:'Judgment',
			layout:'col s12'
		},
		
		{
			label: "Date Delivered",
			name: "date_delivered",
			type:'date',
			values:'',
			readonly:false,
			layout:'col s6',
			isFor:'Judgment',
		},
		{
			name: "author",
			label: "Author",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s12'
		
		},
		{
			name: "classification",
			label: "Classification",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s12'
		
		},
		{
			name: "edition",
			label: "Edition",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s12'
		
		},
		{
			name: "isbn",
			label: "ISBN",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s6'
		
		},
	
		{
			name: "publication_date",
			label: "Publication Date",
			type: "date",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s6'
		
		},
		{
			name: "publisher",
			label: "Publisher",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s12'
		
		},
		{
			name: "series",
			label: "Series",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s12'
		
		},
		{
			name: "year",
			label: "Year",
			type: "text",
			values: "",
			isFor: 'Book',
			readonly:false,
			layout:'col s6'
		
		},
		
		{
			label: "Page Count",
			name: "page_count",
			type: "number",
			values:'',
			readonly:false,
			isFor:['Judgment', 'Legislation', 'Book'],
			layout:'col s6',
		},
		///No file upload for book yet
		
		{
			label: "File upload",
			name: "file_upload",
			type: "file_upload",
			isMultiple: false,
			values:'',
			readonly:false,
			isFor:['Judgment', 'Legislation', 'Book'],
			layout:'col s12'
		}
]

const generate = () =>{
	return fields.map(x => {
		if (typeof x.values === 'object' && x.values !== null) {
			x.values = {}
			return x
		} else {
			x.values = ''
			return x
		}
	})
}

const populate = (data) => {
	fields.forEach(item => {
		let key = item.name
		let v = data[key]
		
		if (item.dataType === 'Object'){
			v = item.options.find(a => a.prop === v)
		}
		if(item.type === 'file_upload') v = [data[key]]
		if(data[key]) {
			item.values = v
	
		}
	})
	return fields
}

export default {
	fields, generate, populate
}